import PropTypes from 'prop-types';

/** A prize as returned by the JSON:API `/api/prizes/` list endpoint. */
const prizePropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  attributes: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    image: PropTypes.string,
    status: PropTypes.oneOf(['Active', 'Inactive', 'Upcoming']).isRequired,
    valid_from: PropTypes.string.isRequired,
    valid_to: PropTypes.string.isRequired,
    is_participating: PropTypes.bool
  }).isRequired
});

export default prizePropType;
